import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import { Finanzmanager } from "@/application/router/types/types";
import AccountView from "@/user/account/index.vue";
import DatenView from "@/user/data/index.vue";
import BankAccountsView from "@/user/bankAccount/pages/index.vue";
import MainLayout from "@/application/layouts/MainLayout.vue";
import SimpleMessage from "@/application/components/SimpleMessage.vue";
import { confirmEmailChange, confirmEditEmail, confirmPasswordChange } from "@/api/account/accountApi";
import type { SimpleMessageProps } from "@/application/components/SimpleMessageProps";
import { useBaseDataStore } from '@/user/store/baseDataStore';
import type { ConfirmData } from "@/api/account/types";
import BankAccountDetailsPage from '@/user/bankAccount/pages/BankAccountDetailsPage.vue';

export const accountRoutes: RouteRecordRaw[] = [
  {
    path: '/account',
    component: MainLayout,
    meta: {
      title: 'Mein Account',
    },
    children: [
      {
        path: '',
        name: Finanzmanager.ACCOUNT,
        component: AccountView,
        beforeEnter: (to: RouteLocationNormalized) => {
          const { isCompany } = useBaseDataStore();
          to.meta.title = isCompany ? 'Unser Account' : 'Mein Account';
          return;
        },
      },
      {
        path: 'confirm-edit-email',
        component: SimpleMessage,
        meta: {
          public: true
        },
        props: (route): SimpleMessageProps<ConfirmData, string> => {
          return {
            confirmToken: route.query.confirmToken as string ?? null,
            apiCall: confirmEditEmail,
            afterConfirmationRoute: '/'
          }
        }
      },
      {
        path: 'confirm-email-change',
        component: SimpleMessage,
        meta: {
          public: true
        },
        props:
          (route): SimpleMessageProps<ConfirmData, string> => {
          return {
            confirmToken: route.query.confirmToken as string ?? null,
            apiCall: confirmEmailChange,
            afterConfirmationRoute: '/'
          }
        }
      },
      {
        path: 'confirm-password-change',
        component: SimpleMessage,
        meta: {
          public: true
        },
        props: (route): SimpleMessageProps<ConfirmData, string> => {
          return {
            confirmToken: route.query.confirmToken as string ?? null,
            apiCall: confirmPasswordChange,
            invalidatesAuth: true,
            afterConfirmationRoute: '/login'
          }
        }
      }
    ]
  },
  {
    path: '/daten',
    meta: {
      title: 'Meine Daten',
    },
    component: MainLayout,
    children: [
      {
        path: '',
        name: Finanzmanager.DATEN,
        component: DatenView,
        meta: {
          footerInContent: true,
        },
        beforeEnter: (to: RouteLocationNormalized) => {
          const { isCompany } = useBaseDataStore();
          to.meta.title = isCompany ? 'Unsere Daten' : 'Meine Daten';
          return;
        },
      },
    ]
  },
  {
    path: '/bank-accounts',
    meta: {
      title: 'Bankverbindungen',
    },
    component: MainLayout,
    children: [
      {
        path: '',
        name: Finanzmanager.BANK_ACCOUNTS,
        component: BankAccountsView,
        meta: {
          title: 'Bankverbindungen',
        },
      },
      {
        path: ':accountId',
        name: Finanzmanager.BANK_ACCOUNT_DETAILS,
        component: BankAccountDetailsPage,
        meta: {
          title: 'Bankverbindung',
        },
      },
    ]
  }
]
